import currencies from "../data/currencies";

export default function useCurrency(currency) {
  const currencyObj = currencies.find((curr) => {
    return curr.title === currency
  });
  return currencyObj;
}